import React, { ComponentProps } from 'react'

// components
import { FieldValues, UseControllerProps, useController } from 'react-hook-form'
import { InputField, Props } from './input-field'

type InputField = ComponentProps<'input'> & Props
type RHFInputFieldType<T extends FieldValues> = UseControllerProps<T> & InputField

export const RHFInputField = <T extends FieldValues>({
  label,
  required = false,
  placeholder,
  fieldWidth = '100%',
  width = '100%',
  marginBottom = 16,
  name,
  size,
  rules,
  maxLength,
  type,
  handleChangeData,
  disabled = false,
  control,
  customInputStyle,
  customStyle,
}: RHFInputFieldType<T>) => {
  const {
    field,
    fieldState: { error },
  } = useController<T>({ name, control, rules })
  return (
    <InputField
      {...field}
      value={field.value === null || field.value === undefined ? '' : field.value}
      label={label}
      required={required}
      fieldWidth={fieldWidth}
      width={width}
      marginBottom={marginBottom}
      size={size}
      customInputStyle={customInputStyle}
      customStyle={customStyle}
      error={error?.message}
      handleChangeData={e => {
        field.onChange(e)
        handleChangeData && handleChangeData(e)
      }}
      maxLength={maxLength}
      type={type}
      placeholder={placeholder}
      disabled={disabled}
    />
  )
}
